export function copyToClipboard(text?: string | null) {
    if (!text) {
        return;
    }

    return navigator.clipboard.writeText(text);
}
